import { useParams } from "react-router";
import { MODELS, useMultiModel } from "../../api";
import { ShellContent } from "../shell/Shell.jsx";
import tokens from "../../design-system/tokens.js";
import { useSparkContext } from "../workshops/context/SparkContext.jsx";
import { FullShowroomEntryWithData } from "../workshops/showroom/components/FullShowroomEntry/FullShowroomEntryWithData.jsx";

/**
 * Creates a FullShowroomEntry with the data relevant for the demo mode.
 */
const FullShowroomEntry = () => {
  const { smallTeamId } = useParams();
  const { spark } = useSparkContext();
  const [showroomData, teamMembers] = useMultiModel([
    MODELS.SMALL_TEAM_SHOWROOM_ENTRY(smallTeamId),
    MODELS.SMALL_TEAM_MEMBERS(smallTeamId),
  ]);

  return (
    <ShellContent bg={tokens.color.full.gray800}>
      <FullShowroomEntryWithData
        entry={showroomData.entry}
        comments={[]}
        myReaction={null}
        myCommentReactions={[]}
        teamMembers={teamMembers}
        me={{}}
        myRoles={[]}
        commentsEnabled={false}
        backPath="../showroom"
        unseenComments={[]}
        sparkId={spark.id}
        workshopId={null}
      />
    </ShellContent>
  );
};

export default FullShowroomEntry;
